import Cookies from 'js-cookie';
import {UAParser} from "ua-parser-js";

async function simpleFetch(url, method = "GET") {
    const response = await fetch(url, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "Token " + Cookies.get('jwtuser')
        }
    }); // Attente de la réponse de l'API

    if (!response.ok) { // Vérification du statut de la réponse (200-299)
        throw new Error(`Erreur HTTP: ${response.status}`);
    }
    try {
        const data = await response.json(); // Conversion des données en format JSON
        return data; // Retour des données
    } catch {
        return response;
    }
}
export function getBreedName(id) {
    if (id) {
        let url = new URL(process.env.REACT_APP_API_URL + `breed/${id}`);
        return simpleFetch(url); //Renvoie une Promise de résultats
    } else {
        throw new Error("Invalid or no id");
    }
}
export async function getLocality(id) {
    if (id) {
        let url = new URL(process.env.REACT_APP_API_URL + `locality/${id}`);
        return simpleFetch(url); //Renvoie une Promise de résultats
    } else {
        throw new Error("Invalid or no id");
    }
}
export async function getLocalities(search, countryId) {
    let url = new URL(process.env.REACT_APP_API_URL + `locality`);
    if (search) url.searchParams.set('filter', search);
    if (countryId) url.searchParams.set('country', countryId);
    return simpleFetch(url); //Renvoie une Promise de résultats
}
export async function getCountry(id) {
    if (!id) {
        throw new Error("Invalid or no id");
    }
    try {
        const url = new URL(`${process.env.REACT_APP_API_URL}country`);
        const countries = await simpleFetch(url); // Attend la résolution de la promesse

        return countries.find((country) => country.id === id);
    } catch (error) {
        throw new Error(`Error fetching country: ${error.message}`);
    }
}
export function loadCountries(setCountries, navigate) {

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status >= 200 && xhttp.status < 300) {
            setCountries(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "country", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadLocality(setLocalities, navigate, search, countryId) {

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status >= 200 && xhttp.status < 300) {
            setLocalities(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };

    let url = new URL(process.env.REACT_APP_API_URL + "locality");
    if (search) url.searchParams.set('filter', search);
    if (countryId) url.searchParams.set('country', countryId);
    xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export async function getLocalityAsync(navigate, search) {
    try {
        document.getElementById("loading").style.display = "flex"
        let url = new URL(process.env.REACT_APP_API_URL + "locality");
        if (search) url.searchParams.set("filter", search);

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response.ok) {
            return await response.json();
        } else if (response.status === 401 || response.status === 403) {
            Cookies.remove("jwtuser");
            navigate("/forbidden");
        } else {
            navigate("/error");
        }
    } catch (error) {
        navigate("/error");
    } finally {
        document.getElementById("loading").style.display = "none"
    }
}
export function loadPrescribers(setPrescribers, navigate) {
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status >= 200 && xhttp.status < 300) {
            setPrescribers(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "prescriber", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadGlobalStatus(setStatus, navigate) {

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status >= 200 && xhttp.status < 300) {
            setStatus(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "global_status", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadSpecies(setSpecies, navigate) {

    const xhttp = new XMLHttpRequest();

    xhttp.onload = function () {
        if (xhttp.status === 200) {
            setSpecies(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };

    xhttp.open("GET", process.env.REACT_APP_API_URL + "species", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();

}
export function loadAnimalSex(setAnimalSex, navigate) {

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status === 200) {
            setAnimalSex(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "animal_sex", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadSterilisationStatus(setSterilisationStatus, navigate) {

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status === 200) {
            setSterilisationStatus(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "sterilisation_status", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadPatientResultPref(setData, navigate) {

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status === 200) {
            setData(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "patient_result_preference", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadUrgentResultPref(setData, navigate) {

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status === 200) {
            setData(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "urgent_result_preference", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadMatrix(setMatrix, navigate) {

    const xhttp = new XMLHttpRequest();

    xhttp.onload = function () {

        if (xhttp.status === 200) {
            const data = JSON.parse(this.responseText);
            setMatrix(data);
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };

    xhttp.open("GET", process.env.REACT_APP_API_URL + "matrix", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function getAnalyses(specieId, navigate) {
    return new Promise((resolve, reject) => {
        if (specieId) {
            const xhttp = new XMLHttpRequest();

            xhttp.onload = function () {
                document.getElementById("loading").style.display = "none"
                if (xhttp.status === 200) {
                    const response = JSON.parse(this.responseText);
                    const analysesData = response.categories;
                    const bilansData = response.bilans;
                    resolve({ analysesData, bilansData });
                } else if (xhttp.status === 401 || xhttp.status === 403) {
                    navigate("/forbidden");
                    Cookies.remove('jwtuser');
                    reject(new Error("Unauthorized"));
                } else {
                    navigate("/error");
                    reject(new Error("Error fetching data"));
                }
            };

            let url = new URL(process.env.REACT_APP_API_URL + "analyse");
            if (specieId) url.searchParams.set('species', specieId);
            xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
            xhttp.send();
            document.getElementById("loading").style.display = "flex"
        } else {
            document.getElementById("loading").style.display = "none"
            reject(new Error("Invalid specieId"));
        }
    });
}
export function getAvailableAnalyses(specieId, orderId, navigate) {
    return new Promise((resolve, reject) => {
        if (orderId && specieId) {
            const xhttp = new XMLHttpRequest();

            xhttp.onload = function () {
                if (xhttp.status === 200) {
                    const response = JSON.parse(this.responseText);
                    const availableAnalysesData = response.categories;
                    const availableBilansData = response.bilans;
                    resolve({ availableAnalysesData, availableBilansData });
                } else if (xhttp.status === 401 || xhttp.status === 403) {
                    navigate("/forbidden");
                    Cookies.remove('jwtuser');
                    reject(new Error("Unauthorized"));
                } else {
                    navigate("/error");
                    reject(new Error("Error fetching data"));
                }
            };

            let url = new URL(process.env.REACT_APP_API_URL + "analyse");
            url.searchParams.set('order', orderId);
            url.searchParams.set('species', specieId);
            xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
            xhttp.send();
        } else {
            reject(new Error("Invalid order or specie ID"));
        }
    });
}
export function getOrder(orderId, navigate) {
    return new Promise((resolve, reject) => {
        if (orderId) {
            const xhttp = new XMLHttpRequest();

            xhttp.onload = function () {
                if (xhttp.status === 200) {
                    const response = JSON.parse(this.responseText);
                    resolve(response);
                } else if (xhttp.status === 401 || xhttp.status === 403) {
                    navigate("/forbidden");
                    Cookies.remove('jwtuser');
                    reject(new Error("Unauthorized"));
                } else {
                    navigate("/error");
                    reject(new Error("Error fetching data"));
                }
            };
            let url = new URL(process.env.REACT_APP_API_URL + `order/${orderId}`);
            xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
            xhttp.send();
        } else {
            reject(new Error("Invalid order ID"));
        }
    });
}
export function loadAccount(setAccount, navigate, fillData) {
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status === 200) {
            if (fillData !== undefined) {
                fillData(JSON.parse(this.responseText));
            } else if (setAccount !== undefined) {
                setAccount(JSON.parse(this.responseText));
            }
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "account", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.send();
}
export function loadOrders(navigate, setOrders, option) {
    const xhttp = new XMLHttpRequest();

    xhttp.onload = function () {
        if (xhttp.status === 200) {
            setOrders(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };

    let url = new URL(process.env.REACT_APP_API_URL + 'order');
    if (option.page) url.searchParams.set('page', JSON.stringify(option.page));
    if (option.per_page) url.searchParams.set('per_page', JSON.stringify(option.per_page));
    if (option.isPrescriber) url.searchParams.set('is_prescriber', option.isPrescriber.toString());
    if (option.search) url.searchParams.set('filter', option.search);
    if (option.specie) url.searchParams.set('species', option.specie);
    if (option.global_status) url.searchParams.set('global_status', option.global_status);
    xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.send();

}
export function loadActualities(navigate, setNews) {

    const xhttp = new XMLHttpRequest();

    let newsArray = [];
    xhttp.onload = function () {

        if (xhttp.status === 200) {
            const data = JSON.parse(this.responseText);

            data.forEach((item) => {
                newsArray.push({
                    id: item.id,
                    date: item.date,
                    icon: item.icon,
                    color: item.color,
                    title: item.title,
                    content: item.content
                })
            });
            setNews(newsArray);
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    }
    xhttp.open("GET", process.env.REACT_APP_API_URL + "actuality", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function signin(username, password, navigate, from) {
    const info = {
        username: username,
        password: password
    }
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status >= 200 && xhttp.status < 300) {
            Cookies.set('jwtuser', JSON.parse(this.responseText).token[0], { expires: 30 });
            navigate(from);
        } else {
            alert(this.responseText);
        }
    }
    xhttp.open("POST", process.env.REACT_APP_API_URL + "login", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhttp.send(JSON.stringify(info));
}
export function signout(navigate) {
    alert('Vous êtes déconnecté.')
    Cookies.remove('jwtuser');
    navigate('/');
}
export function loadReport(id, navigate) {

    document.getElementById("loading").style.display = "flex";

    const newWindow = window.open("", "_blank");
    newWindow.document.write("<p>Chargement du PDF...</p>");
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status === 200) {
            const blob = new Blob([xhttp.response], { type: 'application/pdf' });
            const urlBlob = URL.createObjectURL(blob);
            newWindow.location.href = urlBlob;

        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else if (xhttp.status === 404) {
            alert('Pas de rapport disponible');
        } else {
            navigate("/error");
        }
        document.getElementById("loading").style.display = "none";
    };

    let url = new URL(process.env.REACT_APP_API_URL + 'report/pdf/' + id.toFixed(0));
    xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.responseType = 'blob';
    xhttp.send();

}
export function loadMicrobioteReport(id, navigate) {

    document.getElementById("loading").style.display = "flex";

    const newWindow = window.open("", "_blank");
    newWindow.document.write("<p>Chargement du rapport...</p>");

    const xhttp = new XMLHttpRequest();

    xhttp.onload = function () {
        if (xhttp.status === 200) {

            // 👉 on récupère le HTML brut
            const htmlContent = xhttp.responseText;

            // 👉 on remplace le contenu de la fenêtre
            newWindow.document.open();
            newWindow.document.write(htmlContent);
            newWindow.document.close();

        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else if (xhttp.status === 404) {
            alert('Pas de rapport disponible');
        } else {
            navigate("/error");
        }

        document.getElementById("loading").style.display = "none";
    };

    let url = new URL(process.env.REACT_APP_API_URL + 'report_microbiote/' + id.toFixed(0));

    xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));

    // 👉 IMPORTANT : plus de blob !
    xhttp.responseType = 'text';

    xhttp.send();
}
export function loadPurchaseOrder(id, navigate) {

    document.getElementById("loading").style.display = "flex";

    const newWindow = window.open("", "_blank");
    newWindow.document.write("<p>Chargement du PDF...</p>");

    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        document.getElementById("loading").style.display = "none";

        if (xhttp.status === 200) {
            const blob = new Blob([xhttp.response], { type: 'application/pdf' });
            const urlBlob = URL.createObjectURL(blob);
            newWindow.location.href = urlBlob;
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
            newWindow.close();
        } else if (xhttp.status === 404) {
            alert('PDF de prescription non disponible');
            newWindow.close();
        } else {
            navigate("/error");
            newWindow.close();
        }

    };

    const url = new URL(process.env.REACT_APP_API_URL + 'purchase_order/pdf/' + id.toFixed(0));
    xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.responseType = 'blob';
    xhttp.send();

}
export function setStripeKey(id, setKey) {

    const xhttp = new XMLHttpRequest();

    xhttp.onload = function () {
        if (xhttp.status === 200) {
            setKey(JSON.parse(this.responseText).session);
        } else {
            setKey("error");
        }
    };

    let url = new URL(process.env.REACT_APP_API_URL + 'payment_session');
    if (id) url.searchParams.set('id', JSON.stringify(id));
    xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export function loadContacts(setContact, navigate) {
    const xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        if (xhttp.status >= 200 && xhttp.status < 300) {
            setContact(JSON.parse(this.responseText));
        } else if (xhttp.status === 401 || xhttp.status === 403) {
            navigate("/forbidden");
            Cookies.remove('jwtuser');
        } else {
            navigate("/error");
        }
    };
    xhttp.open("GET", process.env.REACT_APP_API_URL + "contact", process.env.REACT_APP_API_HTTPS);
    xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
}
export async function callDriver() {
    let url = new URL(process.env.REACT_APP_API_URL + `driver_call`);
    await simpleFetch(url, "POST");
    return;
}
export function getMaterialForm(navigate) {
    return new Promise((resolve, reject) => {
        const xhttp = new XMLHttpRequest();

        xhttp.onload = function () {
            if (xhttp.status === 200) {
                const response = JSON.parse(this.responseText);
                resolve(response);
            } else if (xhttp.status === 401 || xhttp.status === 403) {
                navigate("/forbidden");
                Cookies.remove('jwtuser');
                reject(new Error("Unauthorized"));
            } else {
                navigate("/error");
                reject(new Error("Error fetching data"));
            }
        };
        let url = new URL(process.env.REACT_APP_API_URL + `material/form`);
        xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
        xhttp.setRequestHeader("Content-type", "application/json");
        xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
        xhttp.send();
    });
}
export function getMaterialOrderHistory(navigate) {
    return new Promise((resolve, reject) => {
        const xhttp = new XMLHttpRequest();

        xhttp.onload = function () {
            if (xhttp.status === 200) {
                const response = JSON.parse(this.responseText);
                resolve(response);
            } else if (xhttp.status === 401 || xhttp.status === 403) {
                navigate("/forbidden");
                Cookies.remove('jwtuser');
                reject(new Error("Unauthorized"));
            } else {
                navigate("/error");
                reject(new Error("Error fetching data"));
            }
        };
        let url = new URL(process.env.REACT_APP_API_URL + `material/command`);
        xhttp.open("GET", url, process.env.REACT_APP_API_HTTPS);
        xhttp.setRequestHeader("Content-type", "application/json");
        xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
        xhttp.send();
    });
}
export function sendMaterialOrder(navigate, body) {
    return new Promise((resolve, reject) => {
        const xhttp = new XMLHttpRequest();

        xhttp.onload = function () {
            if (xhttp.status === 201) {
                resolve(this.responseText);
            } else if (xhttp.status === 401 || xhttp.status === 403) {
                navigate("/forbidden");
                Cookies.remove('jwtuser');
                reject(new Error("Unauthorized"));
            } else {
                navigate("/error");
                reject(new Error("Error fetching data"));
            }
        };
        let url = new URL(process.env.REACT_APP_API_URL + `material/command`);
        xhttp.open("POST", url, process.env.REACT_APP_API_HTTPS);
        xhttp.setRequestHeader("Content-type", "application/json");
        xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
        xhttp.send(JSON.stringify(body));
    });
}
export async function logInfo() {

    const token = Cookies.get('jwtuser')
    //Logging information
    // Initialisation du parser
    const parser = new UAParser();
    const browserInfo = parser.getBrowser();
    const osInfo = parser.getOS();

    const userInfo = {
        browserName: browserInfo.name || "Unknown",
        browserVersion: browserInfo.version || "Unknown",
        osName: osInfo.name || "Unknown",
        osVersion: osInfo.version || "Unknown",
        url:window.location.href
    }

    // Envoi API
    const xhttp = new XMLHttpRequest();
    xhttp.open("POST", process.env.REACT_APP_API_URL + "log");
    xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhttp.setRequestHeader("Authorization", "Token " + token);
    xhttp.send(JSON.stringify({
        content: JSON.stringify(userInfo)
    }));

}

